// @ts-nocheck
import React, { Suspense, useMemo } from 'react';
import { useGLTF } from '@react-three/drei';

type POIProps = {
  /** Optional override for position [x,y,z] */
  position?: [number, number, number];
  /** Optional override for rotation [x,y,z] in radians */
  rotation?: [number, number, number];
  /** Optional override for uniform scale */
  scale?: number;
};

// Tweak these constants to correctly place your model
const MODEL_POSITION: [number, number, number] = [0, -0.5, -0.1];
const MODEL_ROTATION: [number, number, number] = [0, 0, 0];
const MODEL_SCALE = 8.0;

export default function POI({
  position = MODEL_POSITION,
  rotation = MODEL_ROTATION,
  scale = MODEL_SCALE,
}: POIProps) {
  const url = useMemo(
    () => new URL('./export/CleanedUpRoy-v4.glb', import.meta.url).href,
    []
  );
  return (
    <Suspense fallback={null}>
      <POIInner url={url} position={position} rotation={rotation} scale={scale} />
    </Suspense>
  );
}

function POIInner({
  url,
  position,
  rotation,
  scale,
}: {
  url: string;
  position: [number, number, number];
  rotation: [number, number, number];
  scale: number;
}) {
  const { scene } = useGLTF(url);
  const model = useMemo(() => scene.clone(true), [scene]);
  return (
    <group position={position} rotation={rotation} scale={scale}>
      <primitive object={model} />
    </group>
  );
}

useGLTF.preload(new URL('./CleanedUpRoy.glb', import.meta.url).href);


